/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DropdownButton/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function DropdownButton({
  children,
  viewPath = "/DesignSystem/DropdownButton",
  alignItems = "flex-start",
  backgroundColor = "#ffffff",
  disabled,
  height = "auto",
  minWidth = 200,
  valueWidth = 200,
  onClick,
  focused,
  isInvalid,
  text = "Select",
  maxWidth,
  isMultiChoice,
  placeholder
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="DropdownButton.Vertical"
  data-view-path={viewPath}
 disabled={disabled}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--ai-1-ZAQAC3': alignItems,'--h-4-ZAQAC3': typeof height === 'number' ? `${height}px` : height,'--mw-5-ZAQAC3': typeof minWidth === 'number' ? `${minWidth}px` : minWidth,'--w-6-ZAQAC3': typeof valueWidth === 'number' ? `${valueWidth}px` : valueWidth,'--bc-2-ZAQAC3': focused ? "rgba(0,206,124,0.1)" : disabled ? "transparent" : backgroundColor,'--bc-3-ZAQAC3': focused ? "rgba(0,206,124,0.7)" : disabled ? "#f2f2f2" : isInvalid ? "rgba(224,51,51, 0.75)" : "#f2f2f2"}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="DropdownButton.Text"
  data-view-path={viewPath}
 style={{'--mw-11-ZAQAC3': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--w-6-ZAQAC3': typeof valueWidth === 'number' ? `${valueWidth}px` : valueWidth,'--pr-9-ZAQAC3': isMultiChoice ? "35px" : "8px",'--pt-10-ZAQAC3': disabled ? "1px" : "5px",'--pl-8-ZAQAC3': disabled ? "0px" : "8px",'--c-7-ZAQAC3': placeholder ? "#808080" : "#161616"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}